import React from "react";
import { X } from "lucide-react";
import { trackEvent } from "../utils/analytics";

const VideoModal = ({ isOpen, onClose, videoUrl, title = "Virtual Guards Demo" }) => {
  const handleClose = () => {
    // Track modal close
    trackEvent('video_modal_close', {
      category: 'video_engagement',
      action: 'modal_close',
      label: 'virtual_guards_demo'
    });
    onClose();
  };

  const handleVideoPlay = () => {
    // Track video play
    trackEvent('video_play', {
      category: 'video_engagement',
      action: 'video_play',
      label: 'virtual_guards_demo',
      value: 50
    });
  };

  if (!isOpen) return null;

  // Convert YouTube URL to embed format
  const getEmbedUrl = (url) => {
    const videoId = url.includes('youtu.be/') 
      ? url.split('youtu.be/')[1].split('?')[0]
      : url.split('v=')[1]?.split('&')[0];
    
    return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`;
  };

  return (
    <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="relative w-full max-w-4xl mx-auto">
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute -top-12 right-0 text-white hover:text-red-400 transition-colors duration-300 z-10"
        >
          <X className="w-8 h-8" />
        </button>
        
        {/* Video Container */}
        <div className="relative bg-black rounded-2xl overflow-hidden border border-gray-700/50 shadow-2xl">
          {/* Video Title */}
          <div className="bg-gradient-to-r from-gray-900 to-black px-6 py-4 border-b border-gray-700/50">
            <h3 className="text-xl font-bold text-white">{title}</h3>
          </div>
          
          {/* Video Iframe */}
          <div className="aspect-video">
            <iframe
              src={getEmbedUrl(videoUrl)}
              title={title}
              width="100%"
              height="100%"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              onLoad={handleVideoPlay}
              className="w-full h-full"
            />
          </div>
        </div>
        
        {/* Click outside to close */}
        <div 
          className="absolute inset-0 -z-10" 
          onClick={handleClose}
        />
      </div>
    </div>
  );
};

export default VideoModal;